import RoleForm from "../../../components/Role-form"
import WithSidebar from "../../../layouts/WithSidebar"
import { useLocation, useSearchParams } from "react-router-dom"


const SingleRole = ({edit}) => {

    const {state} = useLocation()
    const [searchParams] = useSearchParams()

    const type = searchParams.get('type')
    return(
        <WithSidebar pageTitle={"Roles Management"} breadcrumb={"Dashboard > Roles"}>
            <RoleForm type={type} state={state}/>
        </WithSidebar>
    )
}
export default SingleRole